import { useMemo } from 'react';
import star1 from '@/assets/svg/star-1.svg';
import star2 from '@/assets/svg/star-2.svg';
import star3 from '@/assets/svg/star-3.svg';
import star4 from '@/assets/svg/star-4.svg';
import star5 from '@/assets/svg/star-5.svg';
import star6 from '@/assets/svg/star-6.svg';
import star7 from '@/assets/svg/star-7.svg';
import star8 from '@/assets/svg/star-8.svg';
import star9 from '@/assets/svg/star-9.svg';
import star10 from '@/assets/svg/star-10.svg';

interface Props {
  visible: boolean;
}

interface StarPoint {
  id: number;
  src: string;
  x: number;
  y: number;
  size: number;
  delay: number;
  duration: number;
}

const STARS = [star1, star2, star3, star4, star5, star6, star7, star8, star9, star10];

function seededRandom(seed: number): number {
  const x = Math.sin(seed + 1) * 10000;
  return x - Math.floor(x);
}

export function StarsLayer({ visible }: Props) {
  const stars = useMemo<StarPoint[]>(() => {
    const cols = 5;
    const rows = 5;
    const cellW = 100 / cols;
    const cellH = 60 / rows;
    const points: StarPoint[] = [];
    let id = 0;
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        if (seededRandom(id * 41) < 0.25) {
          id++;
          continue;
        }
        points.push({
          id,
          src: STARS[Math.floor(seededRandom(id * 17) * STARS.length)]!,
          x: c * cellW + seededRandom(id * 7) * cellW * 0.8 + cellW * 0.1,
          y: r * cellH + seededRandom(id * 13) * cellH * 0.8 + cellH * 0.1,
          size: 14 + seededRandom(id * 19) * 20,
          delay: seededRandom(id * 23) * 4,
          duration: 2 + seededRandom(id * 31) * 3,
        });
        id++;
      }
    }
    return points;
  }, []);

  return (
    <div
      className="layer"
      style={{
        zIndex: 10,
        opacity: visible ? 1 : 0,
        transition: 'opacity 3s ease-in-out',
      }}
    >
      {stars.map((star) => (
        <img
          key={star.id}
          src={star.src}
          alt=""
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: 'auto',
            animationName: 'starTwinkle',
            animationDuration: `${star.duration}s`,
            animationDelay: `${star.delay}s`,
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
          }}
        />
      ))}
    </div>
  );
}
